import React from 'react'
import { DepartmentType } from '#src/generated/graphql'

interface DepartmentExpertHeadlineProps {
  departmentType: DepartmentType
}

const DepartmentExpertHeadline: React.SFC<DepartmentExpertHeadlineProps> = ({ departmentType }) => {
  let expertHeadline
  switch (departmentType) {
    case DepartmentType.CYCLING:
      expertHeadline = 'Cycling Expert'
      break

    case DepartmentType.GOLF:
      expertHeadline = 'Golf Expert'
      break

    case DepartmentType.WINTER_SPORTS:
      expertHeadline = 'Winter Sports Expert'
      break

    case DepartmentType.YACHT_CHARTERS:
      expertHeadline = 'Yacht Charters Expert'
      break

    case DepartmentType.CAMPING:
      expertHeadline = 'Camping & Hiking Expert'
      break

    default:
      expertHeadline = 'Curated Expert'
  }

  return <>{expertHeadline}</>
}

export default DepartmentExpertHeadline
